"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mortgageCommonReducer = void 0;
var MortgageCommonAction_1 = require("@/pages/mortagage/actions/MortgageCommonAction");
exports.mortgageCommonReducer = function (state, action) {
    switch (action.type) {
        case MortgageCommonAction_1.default.ON_TAB_CLICKED: {
            return __assign(__assign({}, state), { mortgageTab: action.payload });
        }
        case MortgageCommonAction_1.default.ON_MENU_CLICKED: {
            return __assign(__assign({}, state), { menuActive: !state.menuActive });
        }
        case MortgageCommonAction_1.default.ON_ARTICLE_TOGGLED: {
            return __assign(__assign({}, state), { articleActiveIndex: state.articleActiveIndex === action.payload ? -1 : action.payload });
        }
        case MortgageCommonAction_1.default.SET_RESULT_VISIBLE: {
            return __assign(__assign({}, state), { isResultVisible: action.payload });
        }
    }
    return state;
};
